import { Helmet } from "react-helmet";
import SelectedPropertyImage from "./_selectedpropertyimage";

export default  function PropertyImage() {
    return (
        <div>
            <Helmet
                title="Property Images"
                meta={[
                    { name: "description", content: "Details of the selected property" },
                ]}
            />
            <SelectedPropertyImage/>
        </div>
    );
}